import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import TableRow from "@mui/material/TableRow";
import borders from "assets/theme/base/borders";
import colors from "assets/theme/base/colors";

function InvoiceTableRow({ data, withheldAmount }) {
  const { borderWidth } = borders;
  const { light } = colors;
  const fontSize = "8pt";
  const borderBottom = `${borderWidth[1]} solid ${light.main}`;

  return (
    <TableRow>
      <SoftBox component="td" textAlign="left" p={1} borderBottom={borderBottom}>
        <SoftTypography variant="body2" color="text" fontSize={fontSize}>
          {data.itemDescr ? data.itemDescr : data.lineComments}
        </SoftTypography>
      </SoftBox>
      <SoftBox component="td" textAlign="left" py={1} pr={1} pl={3} borderBottom={borderBottom}>
        <SoftTypography variant="body2" color="text" fontSize={fontSize}>
          {data.quantity}
        </SoftTypography>
      </SoftBox>
      <SoftBox component="td" textAlign="left" py={1} pr={1} pl={3} borderBottom={borderBottom}>
        <SoftTypography variant="body2" color="text" fontSize={fontSize}>
          {data.measurementUnit ?? "Τεμ."}
        </SoftTypography>
      </SoftBox>
      <SoftBox component="td" textAlign="left" py={1} pr={1} pl={3} borderBottom={borderBottom}>
        <SoftTypography variant="body2" color="text" fontSize={fontSize}>
          {data.netValue.toFixed(2)}
        </SoftTypography>
      </SoftBox>
      <SoftBox component="td" textAlign="left" py={1} pr={1} pl={3} borderBottom={borderBottom}>
        <SoftTypography variant="body2" color="text" fontSize={fontSize}>
          {data.discountAmount ?? 0}
        </SoftTypography>
      </SoftBox>
      <SoftBox component="td" textAlign="left" py={1} pr={1} pl={3} borderBottom={borderBottom}>
        <SoftTypography variant="body2" color="text" fontSize={fontSize}>
          {data.vatCategoryDescription}
        </SoftTypography>
      </SoftBox>
      <SoftBox component="td" textAlign="left" py={1} pr={1} pl={3} borderBottom={borderBottom}>
        <SoftTypography variant="body2" color="text" fontSize={fontSize}>
          {data.vatAmount.toFixed(2)}
        </SoftTypography>
      </SoftBox>
      {withheldAmount > 0 ? (
        <SoftBox component="td" textAlign="left" py={1} pr={1} pl={3} borderBottom={borderBottom}>
          <SoftTypography variant="body2" color="text" fontSize={fontSize}>
            {data.withheldAmount ? data.withheldAmount.toFixed(2) : ""}
          </SoftTypography>
        </SoftBox>
      ) : (
        ""
      )}
      <SoftBox component="td" textAlign="left" py={1} pr={1} pl={3} borderBottom={borderBottom}>
        <SoftTypography variant="body2" color="text" fontSize={fontSize}>
          {(data.netValue + data.vatAmount).toFixed(2)}
        </SoftTypography>
      </SoftBox>
    </TableRow>
  );
}

export default InvoiceTableRow;
